//@ts-check
import React, { Component } from 'react';
import 'Styles/commonComponents/ButtonSwitcher.scss';
import { observer } from "mobx-react";

/**
 * @typedef {object} props
 * @property {string} className
 * @property {() => {itemId: string, text: string}[]} getButtonsInfos
 * @property {() => string} getSelected
 * @property {(itemId: string) => void} setSelected
 * @extends {Component<props>}
 */
class ButtonSwitcher extends Component {
    render() {
        let buttonsInfos = this.props.getButtonsInfos();

        return (
            <div
                className={`ButtonSwitcher ${this.props.className}`}
            >
                {buttonsInfos.map(buttonInfo => (
                    <button
                        key={"ButtonSwitcher_key_" + buttonInfo.itemId}
                        className={
                            "ButtonSwitcher-button "
                            + (this.props.getSelected() == buttonInfo.itemId ? "blue-button " : "")
                            + "ButtonSwitcher-button-" + buttonInfo.itemId
                        }
                        onClick={() => { this.props.setSelected(buttonInfo.itemId) }}>
                        {buttonInfo.text}
                    </button>))}
            </div>
        )
    }
}

export default observer(ButtonSwitcher);